export default __webpack_public_path__ + "static/media/image_10.072c198d.jpg";